define('personalization/listeners/traveler-activity',['adlhelpers', 'personalization/personalization-wrapper', 'validatorhelpers'], function(ADL, personalization, validator) {
    'use strict';

    /*
     * COREUI-550
     *
     * EVENTS:
     *  listing.booknow.click
     */

    function setupListeners(edap) {
        edap.on('listing.booknow.click', function(data) {
            var adl = new ADL(data),
                missingReqs = validator.checkRequiredProperties(adl, ['listingid', 'href', 'eventstartdate', 'eventenddate', 'eventnumadults', 'eventnumchildren', 'eventpets', 'triptotal']);

            if (missingReqs.length > 0) {
                edap.error('Personalization listing.booknow.click missing required properties: ' + missingReqs.join(','), data);
            } else {
                personalization.setCheckout(data);
            }
        });
    }

    return {
        setupListeners: setupListeners
    };
});

